import { render, staticRenderFns } from "./cascadeTM.vue?vue&type=template&id=afe7b2e6&scoped=true&"
import script from "./cascadeTM.vue?vue&type=script&lang=js&"
export * from "./cascadeTM.vue?vue&type=script&lang=js&"
import style0 from "./cascadeTM.vue?vue&type=style&index=0&id=afe7b2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe7b2e6",
  null
  
)

export default component.exports